import { IRoute } from "src/pages/Router/routes";
import ViewSupportTicketPage from "src/pages/Customer/Support/ViewSupportTicketPage";
import { Icons } from "src/library/components/Icon/types";

import ViewCustomerSupportTicketsPage from "./ViewCustomerSupportTicketsPage";
import CreateSupportTicketPage from "./CreateSupportTicketPage";

export const CustomerSupport: IRoute[] = [
  {
    exact: true,
    path: "/support/tickets",
    pageComponent: ViewCustomerSupportTicketsPage,
    title: "Support Tickets",
    icon: Icons.SUPPORT,
    menuTitle: "Support",
    menuType: "MAIN",
    privateRoute: true,
    roles: [ "customer" ],
    modules: [ "support" ],
    canView: ({ global }) => !!global.settings?.supportSettings?.supportTickets.enabled
  },
  {
    exact: true,
    path: "/support/tickets/raise-ticket/:dropId?",
    pageComponent: CreateSupportTicketPage,
    title: "Raise Support Ticket",
    menuType: "MAIN",
    roles: [ "customer", "admin" ],
    hidden: true,
    privateRoute: true,
    canView: ({ global }) => !!global.settings?.supportSettings?.supportTickets.enabled
  },
  {
    exact: true,
    path: "/support/tickets/:supportTicketId",
    pageComponent: ViewSupportTicketPage,
    title: "Support ticket",
    menuTitle: "Support",
    menuType: "MAIN",
    privateRoute: true,
    roles: [ "customer" ],
    modules: [ "support" ],
    hidden: true
  }
];

export default [ ...CustomerSupport ];
